export const getBaseActivityType = (activityType: string | null) => {
  if (activityType?.toLowerCase().includes('running')) {
    return 'running'
  }
  if (activityType?.toLowerCase().includes('cycling') || activityType?.toLowerCase().includes('biking')) {
    return 'cycling'
  }
  if (activityType?.toLowerCase().includes('swimming')) {
    return 'swimming'
  }
  if (
    activityType?.toLowerCase().includes('cross_country_skiing') ||
    activityType?.toLowerCase().includes('skate_skiing')
  ) {
    return 'cross_country_skiing'
  }
  return activityType ?? 'unknown'
}
